export const MESSAGE = 'MESSAGE';
export const DATA = 'DATA';

export default {
    MESSAGE,
    DATA,
};
